/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FirmDetails_photoQuery = {
    readonly firmName: string | null;
    readonly firmUrlLabel: string | null;
    readonly firmProfileIcon: string | null;
    readonly firmInflatedDetails: {
        readonly publicProfile: {
            readonly address: {
                readonly displayCityStateCountry: string | null;
            } | null;
            readonly designProjectsCount: number | null;
        } | null;
    } | null;
    readonly " $refType": "FirmDetails_photoQuery";
};
export type FirmDetails_photoQuery$data = FirmDetails_photoQuery;
export type FirmDetails_photoQuery$key = {
    readonly " $data"?: FirmDetails_photoQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"FirmDetails_photoQuery">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FirmDetails_photoQuery",
  "type": "TradePhotosQueryOutput",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firmName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firmUrlLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firmProfileIcon",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "firmInflatedDetails",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "publicProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmPublicProfileType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "address",
              "storageKey": null,
              "args": null,
              "concreteType": "Address",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayCityStateCountry",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "designProjectsCount",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '29e5681337b8a8f81b30b77d76b37256';
export default node;
